import { forwardRef } from "@wordpress/element";

export const Input = forwardRef(function Input(
	{ label, type = "text", error, style, ...props },
	ref,
) {
	return (
		<label className="steam-input" data-error={Boolean(error)} style={style}>
			{label && <span className="steam-input__label">{label}</span>}

			<input ref={ref} type={type} {...props} />

			{Boolean(error) && <span className="steam-input__error">{error}</span>}
		</label>
	);
});
